<template>
<div class="video">
  <van-popup v-model="showVideo" class="popup" position="top" :close-on-click-overlay="false" :lazy-render="false" @click-overlay="close">
    <div class="close"  @click="close">跳过</div>
    <div class="popup-wrap">
      <div class="popup-title">本次活动由{{$state.brandInfo.name}}特约赞助</div>
      <div class="prism-player" id="player-con"></div>
    </div>
  </van-popup>
</div>
</template>
<script>
import {
  getQueryString
} from 'common/js/util'
export default {
  name: 'video-model',
  data() {
    return {
      showVideo: false,
      player: null
    }
  },
  methods: {
    close(){
        this.timer = null
        this.showVideo = false
        this.$emit("next")
    },
    loadplayer(link) {
      if(getQueryString('not_video') || !link){
        return
      }
      this.showVideo = true
      this.player = new Aliplayer({
        "id": "player-con",
        "source": link,
        "width": "74vw",
        "height": "42vw",
        "autoplay": true,
        "isLive": false,
        "rePlay": false,
        "playsinline": true,
        "preload": true,
        "controlBarVisibility": "hover",
        "useH5Prism": true,
        "skinLayout": [{
          "name": "bigPlayButton",
          "align": "blabs",
          "x": "39.33333%",
          "y": "38%"
        }]
      }, function(player) {
        player.mute();
        player.play();
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.popup-title{
  color:#fff;
  text-align: center;
  margin-bottom:20px;
}
.close{
  border:1px solid #fff;
  color:#fff;
  width:120px;
  height:40px;
  border-radius: 20px;
  line-height: 40px;
  text-align: center;
  float: right;
  margin-top:70px;
  margin-right:40px;
}
.popup-wrap{
  clear: both;
  margin-top:50%;
}
.prism-player{
  margin:0 auto;
}
.video {}
</style>
